import { Box, Line, Tag, Text } from '@factorialco/deprecated-design-system'

export interface Props {
  title: string
  button?: JSX.Element
  isBeta: boolean
}

const MeetingSectionTitle = ({ title, button, isBeta }: Props) => {
  return (
    <Box gap="s16" flexDirection="column">
      <Box gap="s8" flexDirection="row" justifyContent="spaceBetween">
        <Box flexDirection="row" gap="s8" alignItems="center">
          <Text.Header2>{title}</Text.Header2>
          {isBeta && (
            <Box paddingLeft="s8">
              <Tag type="purple">Beta</Tag>
            </Box>
          )}
        </Box>
        {button}
      </Box>
      <Line />
    </Box>
  )
}

export default MeetingSectionTitle
